import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SystemApiService} from "@cv-invision/core";
import {
	SetDeliveryAssetsAcuityDocumentTypes,
	SetDeliveryAssetsAppScopeDocumentTypes, SetDeliveryAssetsClassValuationDocumentTypes,
	SetGenericIntegrations, SetProductListByIntegration
} from "../../state/actions/global-configuration.actions";
import {Store} from "@ngxs/store";
import {INTEGRATIONS} from "../../model/global-configuration.constant";


@Injectable()
export class DeliveryAssetsService {

	private readonly BASE_URL = '/products';

	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService,
		private store: Store
	) {

	}

	getIntegrations(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/products/deliveryAsset/integrations`);
	}

	/**
	 * GET - Return the list of Assets by Origin id
	 */
	getDocumentTypesByOrigin(originId: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/deliveryAsset/doc-types/${originId}`);
	}
}
